export enum CheckTimeEnum {
  CHECK_IN = 'earlyCheckinPrice',
  CHECK_OUT = 'lateCheckoutPrice',
}

export enum HouseOptionsMenusEnum {
  SEASONAL_BUSYNESS_CALENDAR = 'SEASONAL_BUSYNESS_CALENDAR',
  NIGHTLY_TRIP = 'NIGHTLY_TRIP',
  STUDY_DAY = 'STUDY_DAY',
  CORPORATE_EVENING = 'CORPORATE_EVENING',
}
